import { render, staticRenderFns } from "./table-csv-download.vue?vue&type=template&id=27863ccf"
import script from "./table-csv-download.vue?vue&type=script&lang=js"
export * from "./table-csv-download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports